module.exports = __webpack_public_path__ + "img/toilet-paper-blank-under.a8f4a845.svg";